export class Users {
    id: number;
  userId: string;
  userUno: string;
    masterUserID: number;
    userName: string;
    password: string;
    token: string;
    language: string;
    status: number;
    firstName: string;
    lastName: string;
    displayName: string;
    designation: string;
    division: string;
    divisionUno: number;
    phoneNumber: string;
    department: string;
    emailId: string;   
    picture: string;
    accountId: string;
    accountJId: string;
    profileStatus: string;
    chatStatus: string;
    roleId: number;
  role: string;
    hash
    isDisabledforSearch: number;
    profilePicture: string;
    message: string;
    createdBy: number;
    createdDate: string;
    modifiedBy: number;
    modifiedDate: string;
    Flag: string;
    Error: string;
    isMessage: boolean = false;
    messageCount: number = 0;
    isChatVisible: string = "";
    termsandConditions: string;
    groupID: number;
    versionNo: string;
    startIndex: number;
    maxCount: number;
    searchText: string;
    isProfileSearch: boolean = false;
    currentYear: number;
    currentHalf: number;
    currentQuarter: number;
    currentMonth: number;
    tenantUno: number;
  wellperformKPIRange: number;  
  userGroupUno: number;
  userTypeUno: number;
  isLogin: boolean = false;
  lastLogin: string;
  tenantDigitlalUno: number;
  condition: any;
  confirmPassword: string;
  externalUser?: number;
  isBlock?: number;
  tv?: string;

}

export class userType {
  userTypeUno?: number;
  userTypeName?: string;
  userUno: string;
  itemUno: number;
  languageUno?: number;
  condition?: number;
  enteredBy?: number;
  tenantUno?: number;
}

export class RedirectObj {
  code: string;
}

export class usergroup {
  usergroupUno?: number;
  usergroupName?: string;
  rightsXML?: string;
  userUno: string;
  itemUno: number;
  languageUno?: number;
  condition?: number;
  enteredBy?: number;

  pageUno?: number;
  pageName?: string;
  showPage?: boolean;
  showAdd?: boolean;
  showEdit?: boolean;
  showDelete?: boolean;
  pageType?: string;
  sectionName?: string;
  listPage: usergroup[] = [];
  tenantUno?: number;

}
export class usergrouptype {
  usergroupUno?: number;
  usergroupName?: string;
  rightsXML?: string;
  userUno: string;
  itemUno: number;
  languageUno?: number;
  condition?: number;
  enteredBy?: number;

 
  listUserGroup: usergroup[] = [];
  listUserType: userType[] = [];
  tenantUno?: number;

}

export class page {
  pageUno?: number;
  pageName?: string;
  showPage?: boolean;
  showAdd?: boolean;
  showEdit?: boolean;
  showDelete?: boolean;
  pageType?: string;
  sectionName?: string;
  userUno: string;
  itemUno: number;
  languageUno?: number;
  condition?: number;
  tenantUno?: number;
}
export class userrights {
  usergroupUno?: number;
  usergroupName?: string; 
  pageUno?: number;
  pageName?: string;
  showPage?: boolean;
  showAdd?: boolean;
  showEdit?: boolean;
  showDelete?: boolean;
  userUno: string;
  enteredBy: string;
  tenantUno?: number;
  languageUno?: number;
  condition?: number;


}

export class pairText {
  k1?: string;
  i1?: string;
  sik?: string;
}

export class slaNote {
  userUno?: string;
  type?: string;
  userName?: string;
  validState?: string;
}
